import { AiOutlineDashboard } from 'react-icons/ai'
import { BsBoxSeam, BsPercent, BsTruck } from 'react-icons/bs'
import { MdPointOfSale } from 'react-icons/md'

import type { ILink } from '@base/@types/components/Layout/Navigator'

const kpiLinks: ILink = {
  group: 'KPIs',
  icon: <AiOutlineDashboard />,
  roles: [
    'Diretor',
    'Parceiro',
    'Administrador',
    'Logistica',
    'GerenteCategoria',
    'AnalistaPlanejamento',
    'AnalistaCompra',
    'AnalistaDistribuicao',
    'AnalistaComercial',
    'Assistente',
    'GerenteProduto',
    'Analista',
    'Loja',
    'GerenteLoja'
  ],
  menu: [
    {
      name: 'Vendas',
      path: '/kpi/vendas',
      icon: <MdPointOfSale />,
      description: 'Painel de acompanhamento de venda, margem e orçamento ',
      roles: [
        'Diretor',
        'AnalistaCompra',
        'AnalistaDistribuicao',
        'Parceiro',
        'Administrador',
        'AnalistaPlanejamento',
        'GerenteCategoria',
        'GerenteProduto',
        'AnalistaComercial',
        'Assistente',

        'Analista',
        'Loja',
        'GerenteLoja'
      ]
    },
    {
      name: 'Estoque',
      path: '/kpi/estoque',
      icon: <BsBoxSeam />,
      description: 'Painel de acompanhamento de estoque',
      roles: [
        'Diretor',
        'AnalistaCompra',
        'AnalistaDistribuicao',
        'Parceiro',
        'Administrador',
        'AnalistaPlanejamento',
        'GerenteCategoria',
        'GerenteProduto',
        'AnalistaComercial',
        'Assistente',

        'Analista',
        'Loja',
        'GerenteLoja'
      ]
    },
    {
      name: 'Logística',
      path: '/kpi/logistica',
      icon: <BsTruck />,
      description: 'Painel de acompanhamento de performance de fornecedor',
      roles: ['Administrador', 'AnalistaPlanejamento']
    },
    {
      name: 'Ruptura',
      path: '/kpi/ruptura',
      icon: <BsPercent />,
      description: 'Painel de acompanhamento de ruptura',
      roles: [
        'Diretor',
        'AnalistaCompra',
        'AnalistaDistribuicao',
        'Parceiro',
        'Administrador',
        'AnalistaPlanejamento',
        'GerenteCategoria',
        'GerenteProduto',
        'AnalistaComercial',
        'Logistica',

        'Assistente',

        'Analista',
        'Loja',
        'GerenteLoja'
      ]
    }
  ]
}

export default kpiLinks
